module.exports = __webpack_public_path__ + "static/media/award.fc32f775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award.jpg
// module id = 916
// module chunks = 0